import { HttpRequest } from "./HttpRequest";
import { apiUrl } from './Defaults';
import { uuid } from "../helpers/uuid";
import { LocalstorageService } from "../services/localstorage-service";
import { narAppStorageKey } from "../constants/session-storage/auth";

export class DocumentAPI {
  constructor() {
    this._url = `${apiUrl}/document`;
    this._httpRequest = new HttpRequest();
    this.getDocumentTypes = this.getDocumentTypes.bind(this);
    this.uploadToServer = this.uploadToServer.bind(this);
    this.vehicleUploadToServer = this.vehicleUploadToServer.bind(this);
  }

  async getDocumentTypes() {
    return await this._httpRequest.authGet(`${this._url}/types`);
  }

  async getCrlv(documentNumber) {
    if (!documentNumber) {
      throw new Error('documentNumber é obrigatório');
    }

    const authenticatedUserData = LocalstorageService.getData(narAppStorageKey);

    return await this._httpRequest.authGet(`${this._url}/crlv/${documentNumber}?cpf=${authenticatedUserData.cpf}&store=${authenticatedUserData.store}`);
  }

  async uploadToServer(raNumber, image, startedUploadLogParentId) {
    if (!image || !image.blob) {
      throw new Error('Um arquivo é necessário');
    }

    if (!raNumber) {
      throw new Error('Um número de RA é necessário');
    }

    if (!image.classification) {
      throw new Error('A imagem precisa estar classificada');
    }


    const authenticatedUserData = LocalstorageService.getData(narAppStorageKey);

    if (!authenticatedUserData || !authenticatedUserData.cpf) {
      throw new Error('Dados importantes da autenticação estão faltando');
    }

    const body = new FormData();
    body.append('cpf', authenticatedUserData.cpf);
    body.append('classificationId', image.classification);
    body.append('imageId', image.hash);
    body.append('uploadLogParentId', startedUploadLogParentId);
    body.append('file', image.blob);

    return await this._httpRequest.authPostFile(`${this._url}/upload/${raNumber}`, body)
  }

  async vehicleUploadToServer(licensePlate, store, image, startedUploadLogParentId) {
    if (!image || !image.blob) {
      throw new Error('Um arquivo é necessário');
    }

    if (!image.licensePlate) {
      throw new Error('A imagem precisa ter uma placa');
    }

    if (!image.store) {
      throw new Error('A imagem precisa ter uma loja');
    }

    const authenticatedUserData = LocalstorageService.getData(narAppStorageKey);

    if (!authenticatedUserData || !authenticatedUserData.cpf) {
      throw new Error('Dados importantes da autenticação estão faltando');
    }

    const body = new FormData();
    body.append('cpf', authenticatedUserData.cpf);
    body.append('store', image.store.toUpperCase());
    body.append('imageId', image.hash);
    body.append('uploadLogParentId', startedUploadLogParentId);
    body.append('file', image.blob);

    return await this._httpRequest.authPostFile(`${this._url}/upload/vehicle/${licensePlate.toUpperCase()}`, body)
  }
}

export default new DocumentAPI();
